import http from '@/utils/http';

/**
 * Authentication-related API calls
 */
export const authApi = {
  /**
   * 登录 - 获取访问令牌
   * @param {object} credentials - 登录凭据
   * @param {string} credentials.email - 邮箱（必需）
   * @param {string} credentials.password - 密码（必需）
   * @returns {Promise} 返回 JWT 认证资源
   * @example
   * const response = await authApi.login({
   *   email: 'user@example.com',
   *   password: 'password123'
   * });
   * // response.data = {
   * //   accessToken: "eyJhbGc...",
   * //   tokenType: "Bearer",
   * //   expiresIn: 3600,
   * //   refreshToken: "..."
   * // }
   */
  login(credentials) {
    return http.post('/iam/tenant-api/v1/auth/token', credentials);
  },

  /**
   * 发送重置密码验证码
   * @param {object} payload - 验证码请求 { target, channel }
   * @returns {Promise}
   */
  sendPasswordResetCode(payload) {
    return http.post('/iam/tenant-api/v1/verification-codes/password-reset', payload);
  },

  /**
   * 重置密码
   * @param {object} payload - 重置密码数据 { target, verificationCode, newPassword }
   * @returns {Promise}
   */
  resetPassword(payload) {
    return http.put('/iam/tenant-api/v1/users/password/reset', payload);
  },

  /**
   * 解锁账号
   * @param {string} email - 用户邮箱
   * @returns {Promise}
   */
  unlockAccount(email) {
    return http.post(`/iam/tenant-api/v1/auth/${email}/unlock`);
  }
};
